import { throwErrorWithStack } from "./crashlytics";
import {
  fiveStarReviewBtnEl,
  fourStarReviewBtnEl,
  oneStarReviewBtnEl,
  twoStarReviewBtnEl,
  threeStarReviewBtnEl,
  feedbackTextAreaEl,
  feedbackEmailInputEl,
  feedbackThanksEl,
  feedbackDialogEl,
  feedbackThanksOkEl,
  feedbackOkEl,
  feedbackScrollContainerEl,
  feedbackCancelEl,
} from "./elements";
import { getEventParams } from "./analytics";
import { withSpinner } from "./spinner";
import store from "./store";
import { addScrollContainerFocusEventCallback } from "./utils";
import cachedFirestore from "./cachedFirestore";
import { addTouchEvent } from "./events";
import { getLogger } from "./logging";

const log = getLogger("Feedback");

const reviewBtns = [
  oneStarReviewBtnEl,
  twoStarReviewBtnEl,
  threeStarReviewBtnEl,
  fourStarReviewBtnEl,
  fiveStarReviewBtnEl,
];

let _stars = null;
let _review = null;
let _email = null;

feedbackTextAreaEl.addEventListener("input", (event) => {
  _review = event.target.value;
  checkIfNecessaryInfoIsFilled();
});

feedbackEmailInputEl.addEventListener("input", (event) => {
  _email = event.target.value;
});

const isNecessaryInfoIsFilled = () => {
  if (_stars === null && !_review) return false;
  if (_stars < 5 && !_review) return false;
  return true;
};

const checkIfNecessaryInfoIsFilled = () => {
  if (isNecessaryInfoIsFilled()) {
    feedbackOkEl.removeAttribute("disabled");
    feedbackOkEl.style.backgroundColor = "#D3FF02";
    feedbackOkEl.style.color = "black";
    feedbackOkEl.style.borderColor = "black";
    feedbackOkEl.classList.add("button");
  } else {
    feedbackOkEl.setAttribute("disabled", "disabled");
    feedbackOkEl.style.backgroundColor = "#E0E0E0";
    feedbackOkEl.style.color = "#9E9E9E";
    feedbackOkEl.style.borderColor = "#9E9E9E";
    feedbackOkEl.classList.remove("button");
  }
};

const addReviewBtns = (stars) => () => {
  _stars = stars + 1;
  reviewBtns.forEach((btn, i) => {
    if (i <= stars) btn.innerHTML = "★";
    else btn.innerHTML = "☆";
  });
  checkIfNecessaryInfoIsFilled();
};

const cancelReview = () => {
  _stars = null;
  _review = null;
  _email = null;
  feedbackDialogEl.style.display = "none";
};

const submitReview = async () => {
  checkIfNecessaryInfoIsFilled();
  if (feedbackOkEl.hasAttribute("disabled")) return;
  const data = {
    stars: _stars,
    review: _review,
    email: _email || store.user.email,
    timestamp: Date.now(),
    metadata: {
      ...getEventParams(),
      name: store.user.displayName,
      uname: store.profile.uname,
      uid: store.user.uid,
      deviceId: store.deviceId,
      language: navigator.language || navigator.userLanguage,
    },
  };
  if (_stars === 5) store.set("gaveFiveStarsReview", true);
  else if (_stars !== null) store.set("gaveFiveStarsReview", false);
  if (__DEV__) log.debug("Review data", data);
  try {
    await withSpinner(
      cachedFirestore.addDocument({
        reference: "feedback",
        data,
      })
    );
  } catch (error) {
    throwErrorWithStack(error, true);
  }
  feedbackDialogEl.style.display = "none";
  feedbackThanksEl.style.display = "initial";
  if (_stars < 5) feedbackThanksOkEl.style.display = "none";
  else feedbackThanksOkEl.style.display = "block";
};

[feedbackTextAreaEl, feedbackEmailInputEl].forEach((el) =>
  addScrollContainerFocusEventCallback(el, feedbackScrollContainerEl)
);

addTouchEvent(oneStarReviewBtnEl, addReviewBtns(0));
addTouchEvent(twoStarReviewBtnEl, addReviewBtns(1));
addTouchEvent(threeStarReviewBtnEl, addReviewBtns(2));
addTouchEvent(fourStarReviewBtnEl, addReviewBtns(3));
addTouchEvent(fiveStarReviewBtnEl, addReviewBtns(4));
addTouchEvent(feedbackOkEl, submitReview);
addTouchEvent(feedbackCancelEl, cancelReview);
